import Vue from 'vue'
import App from './App.vue'
import Buefy from 'buefy'
import './style.scss'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faPlus, faMinus, faSlidersH, faPlay, faPause, faStop, faVolumeUp,
  faVolumeOff, faVolumeMute, faVolumeDown, faInfo, faLink, faSave, faRedoAlt, faUpload, faFileAudio, faEllipsisV
} from '@fortawesome/free-solid-svg-icons'
import { faDiscord, faTwitterSquare } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faPlus, faMinus, faSlidersH, faPlay, faPause, faStop, faVolumeUp,
  faVolumeOff, faVolumeMute, faVolumeDown, faInfo, faLink, faDiscord, faTwitterSquare, faSave, faRedoAlt, faUpload, faFileAudio, faEllipsisV)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(Buefy, {
  defaultIconComponent: 'font-awesome-icon',
  defaultIconPack: 'fas'
})

Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')
